<template>
  <div>

    <!-- Modal detalles -->
    <b-modal v-if="currentUnifyComponent" ref="modalDetailsUnifyComponentsRef" size="xl" scrollable hide-footer>

      <!-- Header -->
      <template #modal-header="{ close }">
        <h5>Detalles de la unificación de componentes</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>

      <b-row class="max-height-details-components-vs" v-if="currentUnifyComponent">

        <!-- Fecha | Responsable-->
        <b-col md="12">
          <b-list-group class="h-100">
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <b-avatar variant="dark"><i class="fa fa-calendar"></i></b-avatar>
              <span class="mr-auto text-dark ml-3"><div><strong>FECHA:</strong></div> {{
                currentUnifyComponent.created_at }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <b-avatar variant="dark"><i class="fa fa-user"></i></b-avatar>
              <span class="mr-auto text-dark ml-3"><div><strong>RESPONSABLE:</strong></div> {{
                currentUnifyComponent.responsible ? currentUnifyComponent.responsible.name : 'No registra' }}</span>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- componentes unificados -->
        <b-col md="6" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="d-flex align-items-center justify-content-center p-2">
              <h6 class="mt-3"><strong>COMPONENTES UNIFICADOS</strong></h6>
            </b-list-group-item>
            <b-list-group-item v-for="component in currentUnifyComponent.unify_components" :key="component.id"
              class="d-flex align-items-center justify-content-between h-100 p-2">
              <b-avatar variant="danger" class="mr-2" size="sm"
                :text="formatWordToConvertToIcon(component.name)"></b-avatar>
              <small class="mr-auto"><strong>[{{ component.cas_number }}]</strong> {{ component.name }}</small>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- Separador -->
        <b-col md="1" class="d-flex justify-content-center align-items-center">
          <h3><b-badge variant="danger">{{ currentUnifyComponent.unify_components ?
            currentUnifyComponent.unify_components.length : 'No registra' }}</b-badge></h3>
          <i class="fa fa-arrow-right mx-2 text-gray pb-1"></i>
          <h1><b-badge variant="primary">1</b-badge></h1>
        </b-col>

        <!-- Componente de destino -->
        <b-col md="5" class="mt-2">
          <b-list-group class="h-100">
            <b-list-group-item class="d-flex align-items-center justify-content-center">
              <h6 class="my-2"><strong>COMPONENTE DE DESTINO</strong></h6>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-center align-items-center h-100">
              <div class="text-center" v-if="currentUnifyComponent.component">
                <b-avatar variant="primary">{{ formatWordToConvertToIcon(currentUnifyComponent.component.name)
                  }}</b-avatar>
                <div class="mt-2">
                  <small class="mr-auto text-primary"><strong>[{{ currentUnifyComponent.component.cas_number
                      }}]</strong> {{
                        currentUnifyComponent.component.name }}</small>
                </div>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- Detalles generales productos/peligros -->
        <b-col md="12" class="mt-2">
          <!-- Detalles de información - Cantidad de productos químicos que se verán afectados -->
          <b-list-group class="border px-3 pt-2">
            <h6 v-b-toggle.collapse-amount-of-chemicals-that-will-be-affected
              style="cursor: pointer; text-transform: uppercase">
              <strong class="d-flex align-items-center justify-content-between m-0 p-0">
                <div>
                  <i class="fa fa-exclamation-triangle text-danger mr-2" aria-hidden="true"></i>
                  Productos químicos afectados
                </div>
                <div class="d-flex align-items-center">
                  <small class="text-primary mr-2">Clic para ver/ocultar productos</small>
                  <h3>
                    <b-badge class="mr-1 text-white" variant="dark">{{ currentUnifyComponent.affected_products ?
                      currentUnifyComponent.affected_products.length : 'No registra' }}</b-badge>
                  </h3>
                </div>
              </strong>
            </h6>
            <b-collapse id="collapse-amount-of-chemicals-that-will-be-affected">
              <b-table thead-tr-class="table-light" small hover :fields="tableAffectedProducts.fields" :items="currentUnifyComponent.affected_products">
                <template #cell(product)="data"><span class="text-gray">{{ data.item.nombre }}</span></template>
                <template #cell(manufacturer)="data">{{('manufacturer' in data.item && data.item.manufacturer) ? data.item.manufacturer.nombre : 'No registra fabricante'}}</template>
              </b-table>
              <br />
            </b-collapse>
          </b-list-group>
        </b-col>

        <b-col md="12" class="mt-2">
          <!-- Detalles de información - Cantidad de peligros que se verán afectados -->
          <b-list-group class="border px-3 pt-2">
            <h6 style="text-transform: uppercase"><strong
                class="d-flex align-items-center justify-content-between m-0 p-0">
                <div>
                  <i class="fa fa-exclamation-triangle text-danger mr-2" aria-hidden="true"></i> Peligros afectados
                </div>
                <h3>
                  <b-badge class="mr-1 text-white" variant="danger">{{ currentUnifyComponent.affected_dangers_ids ?
                    JSON.parse(currentUnifyComponent.affected_dangers_ids).length : 'No registra' }}</b-badge>
                </h3>
              </strong></h6>
          </b-list-group>
        </b-col>

      </b-row>

    </b-modal>

    <!-- Tabla -->
    <b-row>

      <!-- Tabla -->
      <b-col sm="12">
        <b-table responsive hover thead-class="table-active bg-white" show-empty
          empty-text="No hay resultados para mostrar" :items="tableConfig.items.data" :fields="tableConfig.fields">

          <template v-slot:cell(number_of_unified_components)="data">
            <strong>{{ data.item.unify_components ? data.item.unify_components.length : 'No registra' }}</strong>
          </template>
          <template v-slot:cell(destination_component)="data">
            <strong>[{{ data.item.component.cas_number }}]</strong> {{ data.item.component ? data.item.component.name :
              'No registra' }}
          </template>
          <template v-slot:cell(amount_of_PQ_affected)="data"><strong>{{ data.item.affected_products_ids ?
            JSON.parse(data.item.affected_products_ids).length
            : 'No registra' }}</strong></template>
          <template v-slot:cell(amount_of_hazards_affected)="data"><strong>{{ data.item.affected_dangers_ids ?
            JSON.parse(data.item.affected_dangers_ids).length : 'No registra'
              }}</strong></template>
          <template v-slot:cell(date)="data">{{ data.item.created_at }}</template>
          <template v-slot:cell(responsible)="data">
            {{ data.item.responsible ? data.item.responsible.name : 'No registra' }}
            <br />
            <strong v-if="data.item.responsible">[{{ data.item.responsible.email }}]</strong>
          </template>

          <template v-slot:cell(actions)="data">
            <b-button variant="info" @click="onHandleOpenModalDetails(data.item)" class="text-white">
              <i class="fa fa-eye icon"></i>
              Ver detalles
            </b-button>
          </template>

        </b-table>
      </b-col>

      <!-- Paginación -->
      <b-col sm="12">
        <el-pagination v-model="tableConfig.items.current_page" @size-change="onHandleChangeSizePagination"
          @current-change="onHandleChangePagePagination" :current-page="tableConfig.items.current_page"
          :page-sizes="[10, 30, 50, 100]" :page-size="tableConfig.items.per_page" :total="tableConfig.items.total"
          layout="total, sizes, prev, pager, next" class="float-right"></el-pagination>
      </b-col>

    </b-row>

  </div>
</template>

<script>

// Generales
import { mapActions, mapMutations, mapState } from "vuex";

// Componentes

export default {

  name: "unifyComponentsTableHistory",

  data() {
    return {
      tableAffectedProducts: {
        fields: [
          {
            key: 'product',
            label: 'Producto',
            sortable: false
          },
          {
            key: 'manufacturer',
            label: 'Fabricante',
            sortable: false
          }
        ]
      },
    };
  },

  props: {
    formRef: {
      type: [Object | Function | Array],
      required: true,
    }
  },

  async mounted() {

    await this.getUnifyComponents();

  },

  computed: {

    ...mapState('unifyComponents', [
      'tableConfig',
      'action',
      'currentUnifyComponent',
    ]),

  },

  methods: {

    ...mapMutations("unifyComponents", [
      'setSizePagination',
      'setPagePagination',
      'resetCurrentUnifyComponent',
      'setAction',
      'setCurrentUnifyComponent'
    ]),

    ...mapActions('unifyComponents', {
      getAllUnifyComponents: 'getAll'
    }),

    async onHandleChangeSizePagination(size) {
      this.setSizePagination(size);
      this.setPagePagination(1);
      await this.getUnifyComponents();
    },

    async onHandleChangePagePagination(page) {
      this.setPagePagination(page);
      await this.getUnifyComponents();
    },

    async getUnifyComponents() {
      await this.getAllUnifyComponents({
        page: this.tableConfig.items.current_page, 
        per_page: this.tableConfig.items.per_page
      });
    },

    onHandleOpenModalWatchDetails() {
      this.resetCurrentUnifyComponent();
      this.setAction('DETAILS');
      this.formRef.show()
    },

    onHandleOpenModalDetails(unifyComponent) {
      this.resetCurrentUnifyComponent();
      this.setCurrentUnifyComponent(unifyComponent);
      this.$refs.modalDetailsUnifyComponentsRef.show();
    },

    /**
     * Formatear texto para convertir a icono de 3 letras.
     */
    formatWordToConvertToIcon(word) {
      if (typeof word !== 'string') return "COM";

      return word.trim().split(' ').slice(0, 3).map(x => x.charAt(0).toUpperCase()).join('')
    },

  }

};
</script>

<style scoped></style>
